export var LIST_COMPONENT_MASONRY = 'PostListMasonry';
export var LIST_COMPONENT_SIMPLE = 'PostListSimple';
export var LIST_COMPONENT_MOBILE = 'PostListMobile';
export var ITEM_COMPONENT_LIST_ITEM = 'PostListItem';
export var ITEM_COMPONENT_MOBILE_SIDE_BY_SIDE = 'SideBySideMobile';
export var ITEM_COMPONENT_MOBILE_TOI = 'TextOnImageMobile';
export var ITEM_COMPONENT_POST = 'Post';
